import { EvaluationModuleSlug } from '../../types/evaluation/enums.js';

export interface ScoreInstruction {
  range: string;
  description: string;
}

const moduleInstructions: Record<EvaluationModuleSlug, ScoreInstruction[]> = {
  [EvaluationModuleSlug.EDUCPROFILE]: [
    { range: '0-25%', description: "Non adapté pour l'inclusion" },
    { range: '25-50%', description: "Peu adapté pour l'inclusion" },
    { range: '50-75%', description: "Modérément adapté pour l'inclusion" },
    { range: '75-100%', description: "Suffisamment adapté pour l'inclusion" },
  ],
  [EvaluationModuleSlug.MOTPROFILE]: [
    { range: '0-25%', description: 'Non acquis' },
    { range: '25-50%', description: 'Acquisition modérée' },
    { range: '50-75%', description: 'Acquisition avérée' },
    { range: '75-100%', description: 'Acquisition renforcée' },
  ],
  [EvaluationModuleSlug.SENSOPROFILE]: [
    { range: '0-25%', description: 'Adapté' },
    { range: '25-50%', description: 'Dysfonctionnement modéré' },
    { range: '50-75%', description: 'Dysfonctionnement important' },
    { range: '75-100%', description: 'Dysfonctionnement sévère' },
  ],
};

export const getScaleInstructions = (moduleSlug: EvaluationModuleSlug): ScoreInstruction[] => {
  return moduleInstructions[moduleSlug] ?? [];
};

export const getScoreInterpretation = (score: number, moduleSlug: EvaluationModuleSlug): ScoreInstruction | null => {
  const instructions = getScaleInstructions(moduleSlug);

  for (const instruction of instructions) {
    const [min, max] = instruction.range
      .replace('%', '')
      .split('-')
      .map((value) => Number.parseInt(value, 10));

    if (Number.isNaN(min) || Number.isNaN(max)) {
      continue;
    }

    if (score >= min && score <= max) {
      return instruction;
    }
  }

  return null;
};

export const getPdfScoreClass = (score: number, moduleSlug: EvaluationModuleSlug): string => {
  if (moduleSlug === EvaluationModuleSlug.EDUCPROFILE) {
    if (score <= 24) return 'high';
    if (score <= 50) return 'medium';
    if (score <= 74) return 'medium-low';
    return 'low';
  }

  if (moduleSlug === EvaluationModuleSlug.MOTPROFILE) {
    if (score <= 25) return 'high';
    if (score <= 49) return 'medium';
    if (score <= 69) return 'medium-low';
    return 'low';
  }

  if (score <= 25) return 'low';
  if (score <= 49) return 'medium-low';
  if (score <= 69) return 'medium';
  return 'high';
};
